import axios from "axios";
// initial state
const state = {
  
};

// getters
const getters = {
  
};

// actions
const actions = {
  async UploadFile({ commit }, form) {
    console.log(form);

    const response = await axios.post("/file", form);

    // return axios.post({
    //     url: "/file",
    //     form        
    //   }).then(res => {
    //     console.log("sgdgsdgg----------->", res)
    //     resolve(res.data.data);
    //   }).catch((error) => {
    //     console.log(error);
    //   });
    return response.data;
  },
  GetFile({ commit },id) {
      return axios.get("/file/"+ id ).then(res => {
        return res
      }).catch(err => {
        console.log(err);
      })
  },
};

// mutations
const mutations = {
  
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
